import * as React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { ArrowRight, Sparkles, LayoutGrid, ChartBar, Calendar } from "lucide-react";
const stackedPreviews = [{
  id: 1,
  title: "Structural Analysis",
  icon: ChartBar,
  transform: "-translate-x-[10%] sm:-translate-x-[20%] -translate-y-[15%] -rotate-6 scale-90",
  zIndex: "z-0",
  opacity: "opacity-40 sm:opacity-60",
  accent: "bg-chart-2"
}, {
  id: 2,
  title: "Siding Profiles",
  icon: LayoutGrid,
  transform: "translate-x-[10%] sm:translate-x-[20%] -translate-y-[5%] rotate-6 scale-95",
  zIndex: "z-10",
  opacity: "opacity-60 sm:opacity-80",
  accent: "bg-secondary"
}, {
  id: 3,
  title: "Master Blueprint",
  icon: Calendar,
  transform: "translate-x-0 translate-y-[10%] rotate-0 scale-100",
  zIndex: "z-20",
  opacity: "opacity-100",
  accent: "bg-primary",
  glow: "shadow-2xl shadow-primary/20"
}];
export default function AestheticBundles() {
  return;
}